<template>
	<AsiSkeletonCards v-if="order === null" :num="1" :columns="2" loading/>

	<div v-else>
		<template v-if="isOrderCanceled">
			<v-alert
				border="left"
				:icon="icons.ban"
				type="error"
				class="ma-6 bg-striped"
			>
				{{ $t('order.orderIsCanceled') }}
			</v-alert>
		</template>

		<AsiContentContainer :columns="2">
			<div>
				<OrderCardBasicData :order="order"/>
			</div>
			<div>
				<OrderCardExport :order="order"/>
			</div>
			<div v-if="order.oneTimeEmail">
				<OrderCardContactInformation :order="order"/>
			</div>
			<div>
				<OrderCardPayment :order="order"/>
			</div>
			<div>
				<OrderCardShipment :order="order"/>
			</div>
		</AsiContentContainer>

		<v-divider class="mt-n6"/>

		<AsiContentContainer :columns="1">
			<div>
				<OrderCardPositions :order="order"/>
			</div>
		</AsiContentContainer>

		<AsiConfirmDialog ref="confirm"/>
	</div>
</template>

<script lang="ts">
	import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
	import {IOrderAdmin} from "@/models/order/OrderAdminModels";
	import OrderCardPayment from "@/components/order/admin/OrderCardPayment.vue";
	import AsiSkeletonCards from "@/components/common/AsiSkeletonCards.vue";
	import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
	import OrderCardBasicData from "@/components/order/admin/OrderCardBasicData.vue";
	import OrderCardExport from "@/components/order/admin/OrderCardExport.vue";
	import OrderCardShipment from "@/components/order/admin/OrderCardShipment.vue";
	import OrderCardPositions from "@/components/order/admin/OrderCardPositions.vue";
	import Icon from "@/plugins/icons";
	import {OrderShipmentState} from "@/helpers/constants";
	import AsiBtn from "@/components/common/AsiBtn.vue";
	import AsiConfirmDialog from "@/components/common/AsiConfirmDialog.vue";
	import OrderCardContactInformation from "@/components/order/admin/OrderCardContactInformation.vue";

	@Component({
		components: {
			OrderCardContactInformation,
			AsiConfirmDialog,
			AsiBtn,
			OrderCardPositions,
			OrderCardShipment,
			OrderCardExport, OrderCardBasicData, AsiContentContainer, AsiSkeletonCards, OrderCardPayment
		}
	})
	export default class OrderTabDetails extends Vue {

		@Prop({required: true})
		public order!: IOrderAdmin | null;

		private icons = Icon;
		private loading: boolean = false;

		private get isOrderCanceled(): boolean {
			return this.order?.shipmentState === OrderShipmentState.orderShipmentCanceled;
		}

		@Emit('change')
		public change(): void {
			return;
		}

	}
</script>

<style lang="scss" scoped>
	@import 'src/scss/mixins';

	.bg-striped {
		@include stripedBackground(rgba(255, 255, 255, 0.04), 0.5rem);
	}
</style>
